module.exports = __webpack_public_path__ + "media/images/facebook-8b2198dfa3e823cae90dff97fb598baf.png";